export default "__VITE_ASSET__B4Y9xqBK__"